import { isMobileDevice } from '../device/checkDevice';

const scrollToNext = () => {
    const nav = document.getElementById('nav');
    const hero = document.querySelector('.hero');
    const sibling = hero.nextElementSibling; //Get the first sibling element to the hero.
    const { top } = sibling.getBoundingClientRect(); //Find the top position of the sibling
    const navOffsetHeight = nav.offsetHeight;
    const windowPageYOffset = window.pageYOffset;
    const position = top + windowPageYOffset - navOffsetHeight;

    window.scrollTo({ top: position, behavior: 'smooth' });
};

/**
 * @description Adds device-desktop or device-mobile to html tag
 * and changes video data-src to src to prevent mobile from downloading the video
 */
const videoBackgroundInit = () => {
    const deviceType = isMobileDevice() ? 'mobile' : 'desktop';
    document.querySelector('html').classList.add('device-' + deviceType);
    if (!isMobileDevice()) {
        const backgroundVideo = document.getElementById('background-video');
        if (backgroundVideo) {
            backgroundVideo.src = backgroundVideo.getAttribute('data-src');
        }
    }
};

/**
 * @description Adds test ID to the standalone plan link in richtext
 */
// Note: delete when Cannonball V2 migration happens
const setHeroRichtextTestId = () => {
    const hero = document.getElementById('hero');

    if (hero && hero.classList.contains('hero-cta-emphasis')) {
        const richtextBottom = document.getElementsByClassName('richtext-bottom')[0];
        const richtextLink = richtextBottom && richtextBottom.getElementsByTagName('a')[0];

        if (richtextLink) {
            richtextLink.setAttribute('data-testid', 'signup-standalone-hero');
        }
    }
};

const onHeroInit = () => {

    videoBackgroundInit();

    const hintLink = document.querySelector('.hint a');

    if (hintLink) {
        hintLink.addEventListener('click', scrollToNext);
    }
    setHeroRichtextTestId();
};

export {
    onHeroInit
};
